/**
 * RESPONSIBILITY: which sections make up the Visit page, and in what order.
 *
 * Three bands, three pencils: the banner, what to expect, and the way to get in touch.
 */
import { SectionName } from '@app/sections';
import { SectionUpdate } from '../cms';
import { VisitHero, VisitExpect, VisitCta, Reveal } from '../site';

export function VisitPage() {
  return (
    <main>
      <SectionUpdate name={SectionName.VisitHero}>
        {(c) => <VisitHero c={c} />}
      </SectionUpdate>

      <SectionUpdate name={SectionName.VisitExpect}>
        {(c) => <VisitExpect c={c} />}
      </SectionUpdate>

      <SectionUpdate name={SectionName.VisitCta}>
        {(c) => <Reveal><VisitCta c={c} /></Reveal>}
      </SectionUpdate>
    </main>
  );
}
